var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return Object.keys(_vm.listConfiguration).length && _vm.itemsData
    ? _c(
        "section",
        [
          _c("GridTableComponent", {
            ref: "grid",
            attrs: {
              itemsData: _vm.itemsData,
              gridConfiguration: _vm.gridConfiguration,
              title: _vm.headerTitle,
              toolbarOptions: _vm.toolbarOptionsCustom,
              contextMenuItems: _vm.gridContextMenuItems,
              listName: _vm.listConfiguration["Alias"],
              context: _vm.context,
            },
            on: {
              cellClicked: _vm.openForm,
              contextMenuClicked: _vm.onContextMenuClicked,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }